import { render, staticRenderFns } from "./confirmation-token.vue?vue&type=template&id=5cef5a26&scoped=true&"
import script from "./confirmation-token.vue?vue&type=script&lang=js&"
export * from "./confirmation-token.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-token.vue?vue&type=style&index=0&id=5cef5a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef5a26",
  null
  
)

export default component.exports